var addRule = (function (style) {
    var sheet = document.head.appendChild(style).sheet;
    return function (selector, css) {
        var propText =
            typeof css === "string"
                ? css
                : Object.keys(css)
                      .map(function (p) {
                          return (
                              p +
                              ":" +
                              (p === "content" ? "'" + css[p] + "'" : css[p])
                          );
                      })
                      .join(";");
        sheet.insertRule(
            selector + "{" + propText + "}",
            sheet.cssRules.length
        );
    };
})(document.createElement("style"));

export const generalFixes = function (el) {
    const sections = document.querySelectorAll(".main section");
    if (sections.length) {
        const lastSection = sections[sections.length - 1];
        if (lastSection) {
            const backgroundColor = window.getComputedStyle(lastSection)
                .backgroundColor;

            if (backgroundColor == "rgba(24, 64, 121, 0.1)") {
                document
                    .querySelector(".footer__waves .wave--opace-100")
                    .classList.remove("wave--tiny--white");
                document
                    .querySelector(".footer__waves  .wave--opace-100")
                    .classList.add("wave--tiny--lightblue");
            }
            if (lastSection.classList.contains("single-item")) {
                document
                    .querySelector(".footer__waves .wave--opace-100")
                    .classList.remove("wave--tiny--white");
                document
                    .querySelector(".footer__waves  .wave--opace-100")
                    .classList.add("wave--tiny--yellow");
            }
        }
    }
    if (document.querySelector(".pt-form-group-7")) {
        document
            .querySelectorAll(".pt-form-group-7 input")
            .forEach(function (element) {
                console.log(element);
                element.addEventListener("change", function () {
                    const total = this.value.match(/\d+/);
                    document.querySelector(".pt-uea-custom-amount").value =
                        total[0];
                    setTimeout(function () {
                        document
                            .querySelector(".pt-uea-custom-amount")
                            .dispatchEvent(new Event("keyup"));
                    }, 100);
                });
            });
    }
};

export const adjustBackground = function (el) {
    let h = 0;

    h += parseInt(
        window
            .getComputedStyle(el.querySelector("h1"))
            .height.replace("px", ""),
        10
    );
    console.log(h);
    h += parseInt(
        window
            .getComputedStyle(el.querySelector("h1"))
            .marginBottom.replace("px", ""),
        10
    );
    console.log(h);
    h += parseInt(
        window
            .getComputedStyle(
                el.querySelector(".activities-section .section__title")
            )
            .height.replace("px", ""),
        10
    );
    console.log(h);
    h += parseInt(
        window
            .getComputedStyle(
                el.querySelector(".activities-section .section__title")
            )
            .marginBottom.replace("px", ""),
        10
    );
    console.log(h);
    let actMargin;
    el.querySelectorAll(".activities .activity").forEach(function (item) {
        const itemStyle = window.getComputedStyle(item);
        h += parseInt(itemStyle.height.replace("px", ""), 10);
        h += parseInt(itemStyle.marginBottom.replace("px", ""), 10);
        actMargin = parseInt(itemStyle.marginBottom.replace("px", ""), 10);
    });

    h += actMargin;

    var style = document.createElement("style");

    // Add a media (and/or media query) here if you'd like!
    // style.setAttribute("media", "screen")
    // style.setAttribute("media", "only screen and (max-width : 1024px)")

    // WebKit hack :(
    style.appendChild(document.createTextNode(""));

    // Add the <style> element to the page
    document.head.appendChild(style);

    var sheet = style.sheet;

    sheet.insertRule(
        ".activities-main--background:after { height: calc(" +
            h +
            "px - 30rem); }",
        sheet.cssRules.length
    );
};
